"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const isChunkError = error.name === "ChunkLoadError" || error.message.includes("Loading chunk");

  useEffect(() => {
    if (!isChunkError) {
      fetch("/api/log-client-error", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ message: error.message, digest: error.digest, stack: error.stack, source: `client:root ${window.location.pathname}` }),
      }).catch(() => { /* best-effort — never block the error UI on this */ });
    }
    if (isChunkError) {
      const key = `chunk_reload_${error.digest ?? "unknown"}`;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, "1");
        window.location.reload();
      }
    }
  }, [isChunkError, error.digest]);

  if (isChunkError) {
    return (
      <html>
        <body style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", fontFamily: "sans-serif", color: "#888", fontSize: "14px" }}>
          <p>Refreshing after deployment update…</p>
        </body>
      </html>
    );
  }

  return (
    <html>
      <body style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", fontFamily: "sans-serif", gap: "12px", textAlign: "center", padding: "24px" }}>
        <p style={{ fontWeight: 600, color: "#fff", fontSize: "16px" }}>Something went wrong.</p>
        <p style={{ color: "#888", fontSize: "14px", maxWidth: "360px" }}>{error.message}</p>
        <button
          onClick={reset}
          style={{ border: "1px solid rgba(255,255,255,0.15)", borderRadius: "8px", padding: "8px 16px", fontSize: "14px", color: "#ccc", background: "transparent", cursor: "pointer" }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
